import { FC } from 'react';
import { PackageDetails } from 'ts/package/interfaces/PackageDetails';
import Slider from 'react-slick';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface HotelGalleryProps {
  dealModel: PackageDetails;
}

const HotelGallery: FC<HotelGalleryProps> = ({ dealModel: { info } }) => {
  return (
    <div className="details-slider-images">
      {info.hotelImages.length > 1 && (
        <Slider arrows={true} dots>
          {info.hotelImages.map((image, index) => (
            <div key={index} className="slider-main-image">
              <div className="slider-main-image-title">{image.imageTitle}</div>
              <img src={image.url} alt={image.imageTitle} />
            </div>
          ))}
        </Slider>
      )}
      {info.hotelImages.length === 1 && (
        <div className="slider-main-image position-relative">
          <div className="slider-main-image-title">{info.hotelImages[0].imageTitle}</div>
          <img src={info.hotelImages[0].url} alt={info.hotelImages[0].imageTitle} />
        </div>
      )}
    </div>
  );
};

export default withErrorBoundary(HotelGallery, 'HotelGallery');
